import * as yup from 'yup';
import { DataTableHtmlFormatter } from '../../../../Component/Model/helpers';

export const workforceCommentSchema = (maxCommentLength: number) => yup.object({
   comment : yup.string()
   .nullable()
   .test('commentLengthTest', `Comment is too long! (Max length is ${maxCommentLength} characters)`, value => {
      if (!value) {
         return true;
      }
      return DataTableHtmlFormatter(value, '').length <= maxCommentLength;
   })
})